export default __webpack_public_path__ + "static/media/salud-color.d499bfc6.svg";